// ---------------------------------------------------------------------------
// Limite do alvo do arrasto no histórico (F0).
//
// O alvo da navegação nunca passa das velas JÁ CARREGADAS (menos as 1.000 da janela visível), com ou sem o fim do
// histórico marcado. Antes, enquanto o fim não era marcado, o arrasto acumulava uma "dívida" (alvo além do carregado)
// durante a carga de rede; quando os dados chegavam, a dívida era paga de uma vez (tela parada e depois salto).
// Agora o gesto encosta na borda carregada e, quando o bloco chega, segue de onde estava.
// `totalPoints` é o mesmo limite estável que a cena já recebe (navTotalPoints).
// ---------------------------------------------------------------------------

export const NAV_VISIBLE_CANDLES = 1000;

export function maxNavOffset(totalPoints: number): number {
  return Math.max(0, totalPoints - NAV_VISIBLE_CANDLES);
}

/** Novo alvo do arrasto: alvo atual + movimento do dedo (ganho 1,00 aplicado antes), limitado a [0, borda carregada]. */
export function clampDragTarget(currentTarget: number, offsetMovement: number, totalPoints: number): number {
  return Math.min(maxNavOffset(totalPoints), Math.max(0, currentTarget + offsetMovement));
}

/** O gesto está empurrando contra a borda carregada (espera por carga)? */
export function isAtLoadedEdge(position: number, totalPoints: number, tolerance = 1): boolean {
  return position >= maxNavOffset(totalPoints) - tolerance;
}
